import { render, staticRenderFns } from "./price-uphold-edit.vue?vue&type=template&id=ade3abe6&scoped=true&"
import script from "./price-uphold-edit.vue?vue&type=script&lang=js&"
export * from "./price-uphold-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade3abe6",
  null
  
)

export default component.exports